import { Widget, WidgetType } from '@/modules/gpt-chats/models/widget.model';
import { ChatbotWidget, ChatbotWidgetDesignSettings, WidgetBannerSettings } from './index.type';
import { z } from 'zod';

export const chatbotChatInputSchema = z.object({
  query: z.string().trim().min(1, { message: 'Message is required' }),
});

export type ChatbotChatInput = z.infer<typeof chatbotChatInputSchema>;

export const chatbotChatInputDefaultValue: ChatbotChatInput = {
  query: '',
};

const chatbotWidgteDesignSettingsDefaultValue: ChatbotWidgetDesignSettings & WidgetBannerSettings =
  {
    headerStartColor: '#2C5A9E',
    headerEndColor: '#011645',
    titleColor: '#FFFFFF',
    chatBackgroundColor: '#FFFFFF',
    chatFontColor: '#333333',
    sendButtonBackgroundColor: '#f1f5f9',
    sendButtonFontColor: '#000000',
    borderColor: '#f1f5f9',
    'chat-toggle-button--background-color': '#2C5A9E',
    'chat-toggle-button--color': '#FFFFFF',
    banner: {
      enabled: false,
      imageUrl: '',
      imageId: '',
      text: '',
    },
  };

export const ChatbotWidgetdefaultValue: ChatbotWidget = {
  name: '',
  logo_url: '',
  logo_id: '',
  greeting: '',
  designSettings: chatbotWidgteDesignSettingsDefaultValue,
  site_url: '',
  brand_color: '',
};

export const parseChatbotWidgetData = (data: Widget | undefined): ChatbotWidget => {
  if (!data) return ChatbotWidgetdefaultValue;
  const designSettings = data.widget_settings.find((item) => item.widget_type === WidgetType.CHAT);
  if (!designSettings)
    return {
      name: data.name || '',
      greeting: data.greeting || '',
      logo_url: data.logo_url || '',
      logo_id: data.logo_id || '',
      site_url: data.site_url || '',
      brand_color: data.brand_color || '',
      designSettings: chatbotWidgteDesignSettingsDefaultValue,
    };
  if (!designSettings.fe_style)
    return {
      name: data.name || '',
      greeting: data.greeting || '',
      logo_url: data.logo_url || '',
      logo_id: data.logo_id || '',
      site_url: data.site_url || '',
      brand_color: data.brand_color || '',
      designSettings: chatbotWidgteDesignSettingsDefaultValue,
    };

  const persedDesignSettings = JSON.parse(designSettings.fe_style);
  return {
    name: data.name || '',
    greeting: data.greeting || '',
    logo_url: data.logo_url || '',
    logo_id: data.logo_id || '',
    site_url: data.site_url || '',
    brand_color: data.brand_color || '',
    designSettings: { ...chatbotWidgteDesignSettingsDefaultValue, ...persedDesignSettings },
  };
};
